import React from 'react'
import { Box, CircularProgress } from '@material-ui/core'

const DataLoading = ({ text, progressSize = 40 }) => {
  return (
    <Box
      style={{
        display: 'flex',
        alignItems: 'center',
        gap: '10px',
        justifyContent: 'center',
        my: '3rem'
      }}>
      <CircularProgress size={progressSize} />
      {text || 'Loading, please wait...'}
    </Box>
  )
}

export default DataLoading
